import { defineWorkflow } from './workflow-builder'

/**
 * WF-DSP-02 (RM BAP Destruction — Berita Acara Pemusnahan Raw Material) — nomor workflow 15, entitas `rm_destruction`.
 * Sumber: TL 12B WF-DSP-02 + BA 12F DSR-02 + prototype v7.44. Selisih (laporan 18):
 * - Ditambah status terminal `DSP_RM_REJECTED` ("Ditolak") + aksi `ACT_DSP_RM_REJECT` (alasan wajib): BA/prototype punya
 *   "Tolak" dengan alasan, TL hanya Approve. Barangnya kembali ke antrean Area Not Good.
 * - Pembuatan BA langsung "Menunggu Approval" (Draft hanya jalan masuk workflow, tidak dihuni dokumen).
 * - "Siap Dimusnahkan" (prototype) bukan status baru: label turunan saat semua barang sudah di Area Pemusnahan.
 * - Pembuat dokumen tidak boleh menyetujui sendiri (BA 04 §4.1) — dijaga handler (condition TL `created_by _neq`).
 */
export const WF_BAP_RM = defineWorkflow({
  no: 15,
  code: 'WF-DSP-02',
  name: 'RM BAP Destruction Workflow',
  entity: 'rm_destruction',
  statuses: [
    ['DSP_RM_DRAFT', 'Draft', true, false, '#64748B', 'Jadwal BAP-RM dibuat Admin RM'],
    [
      'DSP_RM_PENDING_APP',
      'Menunggu Approval',
      false,
      false,
      '#F59E0B',
      'Menunggu persetujuan jadwal oleh Supervisor RM'
    ],
    ['DSP_RM_APPROVED', 'Disetujui', false, false, '#10B981', 'Jadwal disetujui, siap diterbitkan tugas pemindahan'],
    ['DSP_RM_ASSIGNED', 'Ditugaskan', false, false, '#06B6D4', 'Operator memindahkan item NG ke Area Pemusnahan'],
    ['DSP_RM_COMPLETED', 'Selesai', false, true, '#059669', 'Pemusnahan selesai, stok keluar permanen, print BAP-RM'],
    ['DSP_RM_REJECTED', 'Ditolak', false, true, '#EF4444', 'Jadwal ditolak Supervisor, barang kembali ke antrean']
  ],
  actors: [
    ['ACT_DSP_RM_ADMIN_RM', 'Admin WH RM', 'admin_wh_rm', null],
    ['ACT_DSP_RM_SPV_RM', 'WH RM Supervisor', 'wh_rm_supervisor', null],
    ['ACT_DSP_RM_OP_RM', 'Operator WH RM', 'operator_wh_rm', null]
  ],
  components: [
    ['CMP_DSP_RM_SUBMIT', 'Tombol Jadwalkan BAP-RM', 'ACTION', { color: '#EF4444', variant: 'primary' }],
    ['CMP_DSP_RM_APPROVE', 'Tombol Approve Jadwal BAP', 'ACTION', {}],
    ['CMP_DSP_RM_REJECT', 'Tombol Tolak Jadwal BAP', 'ACTION', { variant: 'outlined' }],
    ['CMP_DSP_RM_ASSIGN', 'Tombol Terbitkan Tugas Pindah', 'ACTION', {}],
    ['CMP_DSP_RM_FINISH', 'Tombol Tandai Selesai Musnah', 'ACTION', {}],
    ['CMP_DSP_RM_PANEL_HEADER', 'Panel Header BAP-RM', 'PANEL', {}],
    ['CMP_DSP_RM_PANEL_ITEMS', 'Panel Item Barang NG (ZNG-RM)', 'PANEL', {}]
  ],
  actions: [
    ['ACT_DSP_RM_SEND', 'DSP_RM_DRAFT', 'DSP_RM_PENDING_APP', 'CMP_DSP_RM_SUBMIT', false, false, null],
    ['ACT_DSP_RM_APP', 'DSP_RM_PENDING_APP', 'DSP_RM_APPROVED', 'CMP_DSP_RM_APPROVE', false, false, null],
    ['ACT_DSP_RM_REJECT', 'DSP_RM_PENDING_APP', 'DSP_RM_REJECTED', 'CMP_DSP_RM_REJECT', true, true, null],
    ['ACT_DSP_RM_ASSIGN_TASK', 'DSP_RM_APPROVED', 'DSP_RM_ASSIGNED', 'CMP_DSP_RM_ASSIGN', false, false, null],
    [
      'ACT_DSP_RM_COMPLETE',
      'DSP_RM_ASSIGNED',
      'DSP_RM_COMPLETED',
      'CMP_DSP_RM_FINISH',
      false,
      false,
      { is_destroyed: true, destroyed_at: '$NOW' }
    ]
  ],
  eligibility: [
    ['ACT_DSP_RM_SEND', 'ACT_DSP_RM_ADMIN_RM'],
    ['ACT_DSP_RM_APP', 'ACT_DSP_RM_SPV_RM'],
    ['ACT_DSP_RM_REJECT', 'ACT_DSP_RM_SPV_RM'],
    ['ACT_DSP_RM_ASSIGN_TASK', 'ACT_DSP_RM_ADMIN_RM'],
    ['ACT_DSP_RM_COMPLETE', 'ACT_DSP_RM_ADMIN_RM']
  ],
  panels: [
    ['CMP_DSP_RM_PANEL_HEADER', 'DSP_RM_DRAFT', 'write', 'ACT_DSP_RM_ADMIN_RM'],
    ['CMP_DSP_RM_PANEL_HEADER', 'DSP_RM_PENDING_APP', 'read', null],
    ['CMP_DSP_RM_PANEL_HEADER', 'DSP_RM_COMPLETED', 'read', null],
    ['CMP_DSP_RM_PANEL_ITEMS', 'DSP_RM_DRAFT', 'write', 'ACT_DSP_RM_ADMIN_RM'],
    ['CMP_DSP_RM_PANEL_ITEMS', 'DSP_RM_PENDING_APP', 'read', null],
    ['CMP_DSP_RM_PANEL_ITEMS', 'DSP_RM_ASSIGNED', 'read', null]
  ],
  emailStatuses: ['DSP_RM_PENDING_APP', 'DSP_RM_APPROVED', 'DSP_RM_COMPLETED']
})

export type DspRmStatusCode = (typeof WF_BAP_RM.spec.statuses)[number][0]
export const buildWorkflowBapSeed = WF_BAP_RM.build
